import { ITooltipProps, Tooltip, tooltipClasses } from '@private/components';
import { getBorderBase, getFontBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import { ThemedElement } from 'utils/types';

export default styled(Tooltip).attrs(() => ({
  enableArrow: true,
}))<ThemedElement<ITooltipProps>>`
  ${tooltipClasses.message} {
    padding: 12px 10px;
    letter-spacing: 0.4px;
    word-break: normal;
    overflow-wrap: break-word;
  }

  ${({ themePrefix = ['components', 'tooltip'] }: ThemedElement<ITooltipProps>) => css`
    ${tooltipClasses.message} {
      border-style: solid;
      ${getFontBase(themePrefix)};
      ${getBorderBase(themePrefix)};
      background: ${getPrefixedVar(themePrefix, 'bg')};

      &:after {
        border-style: solid;
        border-color: ${getPrefixedVar(themePrefix, 'arrowColor')};
      }
    }
  `}
`;
